// Helpers for converting trade-pack stage codes into user-friendly UI metadata.
// Stages come from trade_packs.job_stages (string[]). We derive a label and a color.

const STAGE_LABEL_OVERRIDES: Record<string, string> = {
  new: "Lead",
  contacted: "Contacted",
  diagnosed: "Diagnosed",
  inspected: "Inspected",
  measured: "Measured",
  load_calc: "Load Calc",
  estimated: "Estimated",
  estimating: "Estimating",
  proposed: "Proposal Sent",
  approved: "Approved",
  scheduled: "Scheduled",
  rough_in: "Rough-In",
  inspection: "Inspection",
  trim: "Trim",
  final_inspection: "Final Inspection",
  installed: "Installed",
  commissioned: "Commissioned",
  in_progress: "In Progress",
  completed: "Completed",
  closed_won: "Closed Won",
  closed_lost: "Closed Lost",
  invoiced: "Invoiced",
  paid: "Paid",
};

const STAGE_COLOR_BORDER: Record<string, string> = {
  new: "border-blue-500/20",
  contacted: "border-purple-500/20",
  diagnosed: "border-purple-500/20",
  inspected: "border-indigo-500/20",
  measured: "border-indigo-500/20",
  load_calc: "border-indigo-500/20",
  estimated: "border-yellow-500/20",
  estimating: "border-yellow-500/20",
  proposed: "border-orange-500/20",
  approved: "border-green-500/20",
  scheduled: "border-orange-500/20",
  rough_in: "border-cyan-500/20",
  inspection: "border-cyan-500/20",
  trim: "border-cyan-500/20",
  final_inspection: "border-cyan-500/20",
  installed: "border-emerald-500/20",
  commissioned: "border-emerald-500/20",
  in_progress: "border-action/30",
  completed: "border-success/30",
  closed_won: "border-success/30",
  closed_lost: "border-destructive/30",
  invoiced: "border-yellow-500/20",
  paid: "border-success/30",
};

const STAGE_BADGE_BG: Record<string, string> = {
  new: "bg-blue-500",
  contacted: "bg-info",
  diagnosed: "bg-purple-500",
  inspected: "bg-indigo-500",
  measured: "bg-indigo-500",
  load_calc: "bg-indigo-500",
  estimated: "bg-yellow-500",
  estimating: "bg-yellow-500",
  proposed: "bg-orange-500",
  approved: "bg-green-500",
  scheduled: "bg-orange-500",
  rough_in: "bg-cyan-500",
  inspection: "bg-cyan-500",
  trim: "bg-cyan-500",
  final_inspection: "bg-cyan-500",
  installed: "bg-emerald-500",
  commissioned: "bg-emerald-500",
  in_progress: "bg-action",
  completed: "bg-success",
  closed_won: "bg-success",
  closed_lost: "bg-destructive",
  invoiced: "bg-yellow-600",
  paid: "bg-success",
};

const DEFAULT_STAGES = ["new", "scheduled", "in_progress", "completed"];

export interface PipelineStage {
  id: string;
  label: string;
  color: string;
}

export function humanizeStage(id: string): string {
  return (
    STAGE_LABEL_OVERRIDES[id] ??
    id.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

export function stageBadgeColor(id: string): string {
  return STAGE_BADGE_BG[id] ?? "bg-muted";
}

export function getPipelineStages(stages: string[] | undefined | null): PipelineStage[] {
  const list = stages && stages.length > 0 ? stages : DEFAULT_STAGES;
  return list.map((id) => ({
    id,
    label: humanizeStage(id),
    color: STAGE_COLOR_BORDER[id] ?? "border-muted",
  }));
}
